import { DeliveryZone, DeliveryZoneCircle, DeliveryZonePolygon } from '@pedix-workspace/utils';
import { getDistance, isPointInPolygon } from 'geolib';

export function getDeliveryCostByZone(
  userLocation: { lat: number; lng: number },
  deliveryZones: DeliveryZone[],
): DeliveryZone | null {
  if (
    userLocation?.lat === undefined ||
    userLocation?.lng === undefined ||
    isNaN(userLocation.lat) ||
    isNaN(userLocation.lng)
  ) {
    console.error('Invalid userLocation provided to getDeliveryCostByZone', userLocation);
    return null;
  }

  return findMatchingDeliveryZone(userLocation, deliveryZones);
}

function findMatchingDeliveryZone(
  location: { lat: number; lng: number },
  deliveryZones: DeliveryZone[],
): DeliveryZone | null {
  for (const deliveryZone of deliveryZones) {
    if (isPointInDeliveryZone(location, deliveryZone)) {
      return deliveryZone;
    }
  }
  return null;
}

function isPointInDeliveryZone(point: { lat: number; lng: number }, zone: DeliveryZone): boolean {
  if (zone.type === 'polygon') {
    const polygonZone = zone as DeliveryZonePolygon;
    const polygonPoints = polygonZone.paths.map(p => ({ latitude: p.lat, longitude: p.lng }));
    return isPointInPolygon({ latitude: point.lat, longitude: point.lng }, polygonPoints);
  } else if (zone.type === 'circle') {
    const circleZone = zone as DeliveryZoneCircle;
    const distance = getDistance(
      { latitude: point.lat, longitude: point.lng },
      { latitude: circleZone.center.lat, longitude: circleZone.center.lng },
    );
    return distance <= circleZone.radius;
  }

  console.warn('Unknown zone type encountered in isPointInDeliveryZone', zone);
  return false;
}
